import { render } from "./CommunicationChart.vue?vue&type=template&id=230c5962&ts=true"
import script from "./CommunicationChart.vue?vue&type=script&lang=ts"
export * from "./CommunicationChart.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__